module.exports = __webpack_public_path__ + "img/custom-design.c52683fb.gif";